<template lang="html">
  <v-card
    outlined
    class="validasi-item mb-3"
    :style="{borderLeft: '4px solid ' + $vuetify.theme.currentTheme[status.color]}"
  >
    <v-card-text class="pb-2">
      <div class="d-flex align-center flex-wrap">
        <v-icon small left>mdi-clock-outline</v-icon>
        <span class="font-weight-bold validasi-item__waktu">
          {{item.jam_mulai | addZero}}:{{item.menit_mulai | addZero}} &ndash; {{item.jam_selesai | addZero}}:{{item.menit_selesai | addZero}}
        </span>
        <v-spacer></v-spacer>
        <v-chip x-small outlined class="mr-1">{{item.jenis == 'kinerja' ? 'Utama' : 'Tambahan'}}</v-chip>
        <v-chip x-small :color="status.color" text-color="white">
          <v-icon x-small left>{{status.icon}}</v-icon>
          {{status.text}}
        </v-chip>
      </div>

      <div v-if="item.nama_aktifitas" class="validasi-item__nama font-weight-medium mt-2">{{item.nama_aktifitas}}</div>
      <p class="validasi-item__keterangan mt-2 mb-1">{{item.keterangan}}</p>

      <div class="caption grey--text text--darken-1">
        Volume {{item.volume}}<span v-if="item.satuan_output"> x {{item.satuan_output}}</span>
        &bull; {{item.kode_aktifitas}}
        <span v-if="item.angka_kredit"> &bull; Angka Kredit {{item.angka_kredit}}</span>
      </div>

      <v-alert
        v-if="item.keterangan_validasi"
        dense
        text
        :color="status.color"
        class="caption mt-2 mb-0"
      >
        <span class="font-weight-medium">Keterangan Validasi :</span> {{item.keterangan_validasi}}
      </v-alert>
    </v-card-text>

    <v-card-actions v-if="!item.status" class="panduan-val-aksi pt-0 px-4 pb-3">
      <v-spacer></v-spacer>
      <v-btn small outlined color="error" :disabled="loading" @click="$emit('tolak', item)">
        <v-icon small left>mdi-close</v-icon> Tolak
      </v-btn>
      <v-btn small color="success" :loading="loading" @click="$emit('terima', item)">
        <v-icon small left>mdi-check</v-icon> Terima
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props:{
    item:{
      type:Object,
      required:true
    },
    loading:Boolean,
  },
  filters:{
    addZero:function(value){
      if (value*1 < 10){
        return '0'+value
      }
      return value
    }
  },
  computed:{
    status(){
      if (this.item.status == 'valid'){
        return {text:'Disetujui', color:'success', icon:'mdi-check'}
      } else if (this.item.status == 'invalid'){
        return {text:'Ditolak', color:'error', icon:'mdi-close'}
      }
      return {text:'Menunggu', color:'info', icon:'mdi-timer-sand'}
    }
  }
}
</script>

<style lang="scss" scoped>
  .validasi-item{
    &__waktu{
      font-size: 14px;
    }
    &__nama{
      font-size: 14px;
      line-height: 1.3;
    }
    &__keterangan{
      font-size: 13px;
      color: rgba(0, 0, 0, 0.87);
      white-space: pre-line;
      overflow-wrap: anywhere;
    }
  }
</style>
